import { render, staticRenderFns } from "./el-time-picker.vue?vue&type=template&id=12c239c0"
import script from "./el-time-picker.vue?vue&type=script&lang=js"
export * from "./el-time-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports